<template>
  <v-dialog
    v-model="open"
    fullscreen
    hide-overlay
    transition="dialog-bottom-transition"
  >
    <v-card color="light">
      <v-toolbar
        color="light"
        elevation="0"
      >
        <v-spacer></v-spacer>
        <v-btn
          icon
          @click="$emit('closeModal')"
          class="mr-2"
        >
          <v-icon large color="accent">mdi-arrow-left-circle-outline</v-icon>
        </v-btn>
      </v-toolbar>
      <itacates></itacates>
    </v-card>
  </v-dialog>
</template>

<script>
import Itacates from '@/views/Subscription'

export default {
  components: { Itacates },
  props: ['open']
}
</script>
